"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customScheduleFormResolver = exports.customScheduleFormSchema = void 0;

var yup = _interopRequireWildcard(require("yup"));

var _yup2 = require("@hookform/resolvers/yup");

var customScheduleFormSchema = yup.object().shape({
  tz: yup.string().nullable().label('Timezone').trim().required(),
  hh: yup.number().label('Hours').required(),
  interval: yup.string().label('Period').required(),
  date: yup.string()
});
exports.customScheduleFormSchema = customScheduleFormSchema;
var customScheduleFormResolver = (0, _yup2.yupResolver)(customScheduleFormSchema);
exports.customScheduleFormResolver = customScheduleFormResolver;